import { projectSubpublisherDestinations } from './projectSubpublisherDestinations'

import type { SubpublisherDestination } from '../elements/DestinationUrlsContent'

const isActiveCuratedRow = (row: ListCampaignSubpublisherResponse) =>
  row.active !== false

type CuratedList =
  | ListCampaignSubpublisherResponse[]
  | { data?: ListCampaignSubpublisherResponse[] }

/**
 * DestinationUrls shares the `['all']` query cache with HandleSubplishers.
 * That cache stores the paginated envelope `{ data, total }`, not a bare array.
 */
export const toCuratedRows = (
  curated?: CuratedList | null
): ListCampaignSubpublisherResponse[] => {
  if (Array.isArray(curated)) return curated
  if (Array.isArray(curated?.data)) return curated.data
  return []
}

export const composeSubpublisherDestinationSections = ({
  curated = [],
  approvalPublishers = [],
  destinationsConfig = []
}: {
  curated?: CuratedList
  approvalPublishers?: SubpublisherApprovalStatus[]
  destinationsConfig?: DestinationUrlsConfig[]
}): SubpublisherDestination[] => {
  const approvalById = new Map(
    approvalPublishers.map(publisher => [publisher.publisher_id, publisher])
  )
  const seen = new Set<string>()
  const sections: SubpublisherDestination[] = []

  toCuratedRows(curated)
    .filter(isActiveCuratedRow)
    .forEach(row => {
      seen.add(row.subpublisher_id)
      const approval = approvalById.get(row.subpublisher_id)

      sections.push({
        publisherId: row.subpublisher_id,
        publisherName: row.name,
        campaignStatus: approval?.campaign_status,
        rejectionReason: approval?.reason,
        destinationUrls: projectSubpublisherDestinations(
          {
            publisher_id: row.subpublisher_id,
            publisher_name: row.name,
            destination_urls: approval?.destination_urls
          },
          destinationsConfig
        )
      })
    })

  approvalPublishers.forEach(publisher => {
    if (seen.has(publisher.publisher_id)) return

    sections.push({
      publisherId: publisher.publisher_id,
      publisherName: publisher.publisher_name,
      campaignStatus: publisher.campaign_status,
      rejectionReason: publisher.reason,
      destinationUrls: projectSubpublisherDestinations(
        publisher,
        destinationsConfig
      )
    })
  })

  return sections
}
